const NAV_SCROLL_OFFSET = 80;
const RETRY_DELAYS_MS = [0, 50, 150, 300, 600];

export function scrollToHomeSection(sectionId, behavior = 'auto') {
  const element = document.getElementById(sectionId);
  if (!element) return false;

  const scrollMarginTop = parseFloat(window.getComputedStyle(element).scrollMarginTop) || 0;
  const top =
    element.getBoundingClientRect().top +
    window.pageYOffset -
    NAV_SCROLL_OFFSET -
    scrollMarginTop;

  window.history.replaceState(null, '', `#${sectionId}`);
  window.scrollTo({
    top: Math.max(0, top),
    behavior,
  });

  return true;
}

export function scrollToHomeSectionWhenReady(sectionId, behavior = 'auto') {
  const timeouts = [];

  const attemptScroll = () => {
    if (scrollToHomeSection(sectionId, behavior)) {
      timeouts.forEach(clearTimeout);
      timeouts.length = 0;
      return true;
    }
    return false;
  };

  RETRY_DELAYS_MS.forEach((delay) => {
    timeouts.push(
      setTimeout(() => {
        attemptScroll();
      }, delay)
    );
  });

  return () => {
    timeouts.forEach(clearTimeout);
  };
}
